import { render, staticRenderFns } from "./fix.vue?vue&type=template&id=79553a47&scoped=true&"
import script from "./fix.vue?vue&type=script&lang=js&"
export * from "./fix.vue?vue&type=script&lang=js&"
import style0 from "./fix.vue?vue&type=style&index=0&id=79553a47&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79553a47",
  null
  
)

export default component.exports